// 兄弟组件传参bus
import Vue from 'vue';
export default new Vue();


// WEBPACK FOOTER //
// ./src/utils/bus.js